import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';

const TermsContainer = styled.div`
  max-width: 900px;
  margin: 0 auto;
  padding: 2rem 1rem;
  line-height: 1.6;
  color: var(--text-primary);
`;

const Title = styled.h1`
  font-size: 2rem;
  font-weight: 700;
  margin-bottom: 0.5rem;
  color: var(--text-primary);
`;

const LastUpdated = styled.p`
  font-style: italic;
  color: var(--text-light);
  margin-bottom: 2rem;
  font-size: 0.9rem;
`;

const Section = styled.section`
  margin-bottom: 2rem;
`;

const SectionTitle = styled.h2`
  font-size: 1.5rem;
  font-weight: 600;
  margin-bottom: 1rem;
  margin-top: 1.5rem;
  color: var(--text-primary);
`;

const Paragraph = styled.p`
  margin-bottom: 1rem;
  color: var(--text-secondary);
  
  strong {
    color: var(--text-primary);
    font-weight: 600;
  }
`;

const List = styled.ul`
  margin-left: 1.5rem;
  margin-bottom: 1rem;
  color: var(--text-secondary);
  
  li {
    margin-bottom: 0.5rem;
  }
`;

const Divider = styled.hr`
  border: none;
  border-top: 1px solid var(--border-color);
  margin: 2rem 0;
`;

const TermsOfServicePage = () => {
  const { t, i18n } = useTranslation();
  const currentDate = new Date().toLocaleDateString(
    i18n.language === 'en' ? 'en-US' : 'ar-EG',
    {
    year: 'numeric', 
    month: 'long', 
    day: 'numeric' 
    }
  );
  const sections = t('terms.sections', { returnObjects: true });

  return (
    <TermsContainer>
      <Title>{t('terms.title')}</Title>
      <LastUpdated>{t('terms.lastUpdated', { date: currentDate })}</LastUpdated>

      {sections.map((section, index) => (
        <React.Fragment key={section.title}>
          <Section>
            <SectionTitle>{section.title}</SectionTitle>
            {section.blocks.map((block, blockIndex) => {
              if (block.type === 'list') {
                return <List key={blockIndex}>{block.items.map((item) => <li key={item}>{item}</li>)}</List>;
              }
              return <Paragraph key={blockIndex}>{block.text}</Paragraph>;
            })}
          </Section>
          {index < sections.length - 1 && <Divider />}
        </React.Fragment>
      ))}
    </TermsContainer>
  );
};

export default TermsOfServicePage;
